import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import { IconVerified, IconLeaf, IconStore } from './Icons';
import verifiedClaimsBadge from '../../../assets/verified-sustainability-claims-white.svg';
import css from './SectionTrustBand.module.css';

const POINTS = [
  {
    key: 'checked',
    Icon: IconVerified,
    titleId: 'LandingPage.trustBand.checked.title',
    titleDefault: 'Checked before listing',
    textId: 'LandingPage.trustBand.checked.text',
    textDefault:
      "Every brand's sustainability claims are assessed against our standards before it can sell.",
  },
  {
    key: 'sustainable',
    Icon: IconLeaf,
    titleId: 'LandingPage.trustBand.sustainable.title',
    titleDefault: 'Claims backed by evidence',
    textId: 'LandingPage.trustBand.sustainable.text',
    textDefault: "We only show sustainability claims we've been able to check against evidence.",
  },
  {
    key: 'brands',
    Icon: IconStore,
    titleId: 'LandingPage.trustBand.brands.title',
    titleDefault: 'Brands that share their evidence',
    textId: 'LandingPage.trustBand.brands.text',
    textDefault: 'Shop a growing community of independent brands.',
  },
];

/**
 * A wide, horizontal "trust band" carrying the ethy Verified mark and the
 * marketplace's core promises. It sits between the product sections as a
 * confident reminder of what makes Ethy different.
 */
const SectionTrustBand = () => {
  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.band}>
          <div className={css.badgeCol}>
            <img
              className={css.badge}
              src={verifiedClaimsBadge}
              alt="ethy verified sustainability claims"
              loading="lazy"
            />
            <span className={css.badgeLabel}>
              <FormattedMessage
                id="LandingPage.trustBand.heading"
                defaultMessage="The ethy Verified promise"
              />
            </span>
          </div>

          <ul className={css.points}>
            {POINTS.map(({ key, Icon, titleId, titleDefault, textId, textDefault }) => (
              <li key={key} className={css.point}>
                <span className={css.pointIcon}>
                  <Icon className={css.icon} />
                </span>
                <span className={css.pointText}>
                  <span className={css.pointTitle}>
                    <FormattedMessage id={titleId} defaultMessage={titleDefault} />
                  </span>
                  <span className={css.pointDesc}>
                    <FormattedMessage id={textId} defaultMessage={textDefault} />
                  </span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SectionTrustBand;
